const WAITER_APP_PATTERN = /^\/[^/]+\/(garcom|estacao)/;
const DASHBOARD_PATH = '/painel';

const unauthorized = (api) => {
    api.interceptors.request.use((config) => config);

    api.interceptors.response.use((response) => response,
        (error) => {
            if (error.response.status === 401) {
                const isWaiterRoute = WAITER_APP_PATTERN.test(window.location.pathname);
                const hasWaiterToken = !!localStorage.getItem('otp_token');

                if (isWaiterRoute && hasWaiterToken) {
                    localStorage.removeItem('otp_token');
                    localStorage.removeItem('otp_user');
                    window.location.href = '/acesso';
                } else {
                    localStorage.removeItem("token");
                    window.dispatchEvent(new Event('auth-token-removed'));
                }
            };

            // A API bloqueia rotas do painel por papel e devolve para onde mandar o usuário.
            // Só redireciona quando ele está dentro do painel, para não tirá-lo de outros fluxos.
            const redirectTo = error.response?.data?.redirect_to;

            if (error.response?.status === 403 && redirectTo && window.location.pathname.startsWith(DASHBOARD_PATH)) {
                window.location.href = redirectTo;
            }

            return Promise.reject(error);
        });
};

export default unauthorized;